module.exports = __webpack_public_path__ + "static/media/logo_seabank.b17de3da.svg";